import { fetchSinToken, fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startClient, clientLogout, clientLoading } from "./client";
import { startFormValid, finishFormValid, errorFormValid } from "./form";
import { paymentLogout } from "./payments";


// Solo se ejecuta al envio de el formulario del LoginForm
export const startLogin = (username, password, rememberMe, formName)=>{
    return async(dispatch, getState)=>{
        dispatch(startFormValid(formName)); //Bloquea el boton submit de el formulario
        dispatch(userSetUsername(username)); //guarda el username en el authReducer
        let data = `username=${username}`;
        data +=  `&password=${password}`
        data += `&grant_type=${getState().auth.type}`;
        const resp = await fetchSinToken('user/login', data, 'POST')
        const body = await resp.json();
        if (!body.ok){
            dispatch(errorFormValid(formName, body.error_description));
            dispatch(finishFormValid(formName)); //Activa de nuevo el boton de el formulario
            // responde falso para que no haga el lastPath
            return false;
        }else {
            if(body.type === 'password' || body.type === 'register'){
                await dispatch(userSetType(body.type));
                dispatch(finishFormValid(formName)); //Activa de nuevo el boton de el formulario
                body.type === 'register' && dispatch(clientLoading(body.data));
                // responde falso para que no haga el lastPath
                return false;
            }
            await dispatch(chekingInit()); //Activa la pantalla "Cargando..."
            await dispatch( login({
                scope: body.scope,
                token: body.access_token,
            }));
            localStorage.setItem('token',body.access_token);
            localStorage.setItem( 'token-valid',new Date().getTime() + body.expires_in );
            if(rememberMe){
                localStorage.setItem('refresh_token',body.refresh_token);
            }
            if(body.scope!== 'admin'){
                await dispatch( startClient() ); //Incia el proceso de creacion y obtencion del redux client
            }
            dispatch(chekingFinish()); //Desactiva la pantalla "Cargando..."
        }
        dispatch(finishFormValid(formName)); //Activa de nuevo el boton de el formulario
        return true;
    }
}

// se cambia el type en el AuthReducer
export const userSetType = (newType) => ({
    type: types.authSetType,
    payload: newType
});

// se guarda el username
export const userSetUsername = (username) => ({
    type: types.authSetUsername,
    payload: username
})

// se ejecuta la primera vez que se carga el AppRouter
export const startCheking =()=>{
    return async(dispatch)=>{
        let resp;
        if(localStorage.getItem('refresh_token')){
            //verifica y actualiza los tokens
            let data = `refresh_token=${localStorage.getItem('refresh_token')}`;
            data += `&grant_type=refresh_token`;
            resp = await fetchSinToken('user/login',data,'POST');
        } else{
            //solo verifica si el token es valido
            resp = await fetchConToken('checkToken'); 
        }

        const body = await resp.json();
        if (body.ok && body.scope === 'app'){
            if(!!body.refresh_token){
                localStorage.setItem( 'token', body.access_token);
                localStorage.setItem( 'refresh_token', body.refresh_token);
                localStorage.setItem( 'token-valid', new Date().getTime() + body.expires_in );
            }
            await dispatch( login({
                scope: body.scope,
                token: localStorage.getItem('token')
            }) ); // copia el token al authReducer
            await dispatch( startClient() ); //Incia el proceso de creacion y obtencion del redux client
        }else {
            await dispatch(startLogout()); //borra los datos tanto del redux como del localStorage
        }
        dispatch(chekingFinish()); //Desactiva la pantalla "Cargando..."
        
    }
}

const login = (data)=>({
    type: types.authLogin,
    payload: data
})

const chekingFinish = () => ( {type:types.authCheckinFinish} );

const chekingInit = () => ( {type:types.authCheckinInit} );

export const startLogout = (voluntario = false) => {
    return async (dispatch) => {
        const theme = localStorage.getItem('theme');
        const lastPath = localStorage.getItem('lastPath') || '/';
        localStorage.clear();
        theme && localStorage.setItem('theme', theme)
        // si el logout fue voluntario borra el lastPath
        await dispatch(clientLogout()); // Regresa al itialState el clientReducer
        await dispatch(paymentLogout()); // Regresa al itialState el paymentReducer
        await dispatch(logout()); // Regresa al itialState el authReducer
        if(voluntario) {
            localStorage.setItem('lastPath', '/');
        } else {
            localStorage.setItem('lastPath', lastPath || '/');
        }
    }
}

const logout = () => ({ type: types.authLogout});

export const startRegister = (folio, user) => {
    return async(dispatch, getState)=>{
        let data = `folio=${folio}`;
        data +=  `&correo=${user.correo}`;
        data +=  `&password=${user.password}`;
        data +=  `&nacimiento=${user.anio}-${user.mes.length < 2 ? '0': ''}${user.mes}-${user.dia.length < 2 ? '0': ''}${user.dia}`;
        data +=  `&celular=${user.celular}`;
        data +=  `&casa=${user.casa}`;
        data +=  `&emergencia=${user.emergencia}`;
        data +=  `&tutor=${user.tutor}`;
        data +=  `&enfermedades=${user.enfermedades}`;
        const resp=await fetchSinToken('user/register', data, 'POST')
        const body = await resp.json();
        if (!body.ok){
            return false;
        }else {
            await dispatch(clientLoading(body.data))
            return true
        }
    }
}

export const startRegisterContrato = (folio) => {
    return async(dispatch, getState)=>{
        let data = `folio=${folio}`;
        const resp=await fetchSinToken('user/register/contrato', data, 'POST')
        const body = await resp.json();
        if (!body.ok){
            return false;
        }else {
            return true
        }
    }
}
